import {getCaption} from "@/util/Helpers";
import {isValidPDF} from "@/util/Validators";

export function validationHandler(column) {
    const errors = []
    if (!column.$dirty) return errors
    for (const property in column.$params) {
        if (property === 'maxLength') {
            !column.maxLength && errors.push('Το μέγεθος του πεδίου δεν μπορεί να είναι μεγαλύτερο από ' + column.$params.maxLength.max - 7 + ' χαρακτήρες.')
            // !column.maxLength && errors.push(store.getters.locales['validationMessages']['maxLength'],[column.$params.maxLength.max])
        } else if (property === 'minLength') {
            !column.minLength && errors.push('Το μέγεθος του πεδίου δεν μπορεί να είναι λιγότερους από ' + column.$params.minLength.min + ' χαρακτήρες.')
            // !column.minLength && errors.push(store.getters.locales['validationMessages']['minLength'].replace('{0}',column.$params.minLength.min),[column.$params.minLength.min])
        } else if (property === 'maxValue') {
            !column.maxValue && errors.push('maxValue')
            // (column.$model !== undefined && column.$model !== null && column.$model.size > column.$params.maxValue.max)
            // && errors.push(store.getters.locales['validationMessages']['maxValue'].replace('{0}',column.$params.maxValue.max),[column.$params.maxValue.max])
        } else if (property === 'numeric') {
            !column.numeric && errors.push('Το πεδίο πρέπει να είναι αριθμός')
        } else if (property === 'required') {
            !column.required && errors.push('Υποχρεωτικό Πεδίο')
        } else if (property === 'afmValidator') {
            !column.afmValidator && errors.push(getCaption('ERROR_VALIDATION_AFM'))
        } else if (property === 'dateValidator') {
            !column.dateValidator && errors.push('Η Ημ/νία πρέπει είναι της μορφής ΗΗ/ΜΜ/ΕΕΕΕ όπου {ΗΗ = αριθμός ημέρας}, {ΜΜ = αριθμός μήνα} και {ΕΕΕΕ = αριθμός έτους}')
        } else if (property === 'datePatternValidator') {
            !column.datePatternValidator && errors.push('Η Ημ/νία πρέπει είναι της μορφής ΗΗ/ΜΜ/ΕΕΕΕ όπου {ΗΗ = αριθμός ημέρας}, {ΜΜ = αριθμός μήνα} και {ΕΕΕΕ = αριθμός έτους}')
        } else if (property === 'emailValidator') {
            !column.emailValidator && errors.push(getCaption('VALIDATION_EMAIL_INVALID'))
        } else if (property === 'namesValidator') {
            !column.namesValidator && errors.push(getCaption('VALIDATION_NAMES_INVALID'))
        } else if (property === 'noFutureDateValidator') {
            !column.noFutureDateValidator && errors.push(getCaption('ERROR_VALIDATION_YEAR_FUTURE_INVALID'))
        } else if (property === 'amountValidator') {
            // !column.required && errors.push(store.getters.locales['validationMessages']['required'])
            !column.amountValidator && errors.push(getCaption('VALIDATION_AMOUNT_INVALID'))
        } else if (property === 'yearValidation') {
            !column.yearValidation && errors.push(getCaption('ERROR_VALIDATION_YEAR_INVALID'))
        } else if (property === 'duplicateAmkaValidator') {
            !column.duplicateAmkaValidator && errors.push(getCaption('ERROR_DUPLICATE_AMKA'))
        } else if (property === 'hmAnalhpshsSyzygouValidator') {
            !column.hmAnalhpshsSyzygouValidator && errors.push(getCaption('ERROR_DPK_OPTIONS_IDIOTITA_ANALHPSH_DATE'))
        } else if (property === 'hmLhxhsSyzSxesisValidator') {
            !column.hmLhxhsSyzSxesisValidator && errors.push(getCaption('ERROR_VALIDATION_HM_LHXHS_SYZ_SXESIS'))
        } else if (property === 'duplicateAfmValidator') {
            !column.duplicateAfmValidator && errors.push(getCaption('ERROR_VALIDATION_AFM_DUPLICATE'))
        } else if (property === 'spesificYearValidator') {
            !column.spesificYearValidator && errors.push(getCaption('ERROR_VALIDATION_SPESIFIC_YEAR'))
        } else if (property === 'isValidPDF') {
            !column.isValidPDF && errors.push('Το αρχείο πρέπει να είναι τύπου pdf και μικρότερο από 50mb')
        }
    }
    return errors.join(' , ').toString()
}
